import * as React from "react"
import { useContext, useState } from "react"
import { Context } from "../../store/store"
import Slider from "react-slick"
import "../../slickslider.css"
import RefundCounter from "../RecoundCounter"
import { Link } from "react-router-dom"

interface SoGehtsProps {
    type?: any
}

const Rezepte: React.FC<SoGehtsProps> = ({ type = "" }) => {
    const { dispatch } = useContext(Context)
    const [arrowVisibilityPrev, setArrowVisbilityPrev] = useState(false)
    const [arrowVisibilityNext, setArrowVisbilityNext] = useState(true)
    var settings = {
        dots: false,
        infinite: true,
        speed: 100,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 4000,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                    arrows: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    speed: 300,
                    infinite: true,
                    slidesToScroll: 1,
                },
            },
        ],
        afterChange: current => {
            switch (current) {
                case 0:
                    setArrowVisbilityPrev(false)
                    setArrowVisbilityNext(true)
                    break
                case 2:
                    setArrowVisbilityNext(false)
                    // code block
                    break
                default:
                    setArrowVisbilityPrev(true)
                    setArrowVisbilityNext(true)
            }
        },
    }
    function CustomNextArrow(props) {
        const { className, style, onClick } = props
        return (
            <div
                className={className + (arrowVisibilityNext ? " flex" : " hidden")}
                style={{
                    alignItems: "center",
                    justifyItems: "center",
                    width: "40px",
                    height: "40px",
                    position: "absolute",
                    right: "20px",
                    backgroundImage: "none",
                    transform: "scaleX(1)",
                }}
                onClick={onClick}
            >
                <svg width="41" height="29" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M28.5845 25.2356L28.592 25.2303L28.5992 25.2246L32.8775 21.8393C32.8778 21.8391 32.8781 21.8389 32.8784 21.8387C33.2842 21.5217 33.7138 21.1787 34.1199 20.7604C36.6506 18.5517 38.1746 17.023 39.0729 15.9432C39.9382 14.9032 40.2653 14.2316 40.3018 13.7336L40.3031 13.7284C40.4211 13.2337 40.2134 12.6186 39.291 11.6278C38.3565 10.624 36.6103 9.15119 33.4289 6.91435C32.9814 6.54078 32.5182 6.24454 32.0815 5.97174C32.0812 5.97155 32.0809 5.97136 32.0806 5.97117L27.4719 3.05164L27.4642 3.04676L27.4562 3.04231C25.5641 1.98253 23.8664 1.23591 22.6565 0.945824L22.6565 0.945817C21.3144 0.624144 20.2109 0.592256 19.3987 0.767469C18.6049 0.938723 17.9948 1.33591 17.8471 1.95172L17.847 1.95201C17.7876 2.20108 17.7837 2.43805 17.8511 2.66562C17.918 2.89177 18.0473 3.08165 18.211 3.24979C18.5169 3.5641 18.9979 3.85282 19.5626 4.19172L19.5964 4.21205C19.5965 4.21209 19.5966 4.21213 19.5966 4.21218C19.6496 4.24418 19.7036 4.27674 19.7589 4.31004C19.9488 4.42441 20.1532 4.54751 20.377 4.68693L20.3769 4.68703L20.3848 4.69165C22.0779 5.68396 24.1508 7.05237 26.3891 8.65104L26.3917 8.65294L26.4059 8.66345L26.4614 8.70457L26.6722 8.86105C26.8537 8.99598 27.1126 9.18897 27.4222 9.42107C27.8399 9.73429 28.3496 10.1185 28.8857 10.5273C28.1921 10.532 27.4308 10.5466 26.5935 10.5737C26.0156 10.5451 25.4721 10.585 24.96 10.6304L8.47217 10.9764L8.45311 10.9768L8.43422 10.9794C7.66697 11.0829 6.94979 11.1362 6.28243 11.1858C6.02906 11.2046 5.78287 11.2229 5.54384 11.2432C4.69375 11.3154 3.91771 11.4138 3.31134 11.6778C2.06268 12.2199 1.31976 12.734 0.946566 13.2628C0.754161 13.5354 0.65896 13.8134 0.646866 14.0943C0.634952 14.371 0.704627 14.6273 0.805126 14.8582C0.844425 14.9488 0.878533 15.0351 0.912368 15.1209L0.915902 15.1299C0.94782 15.211 0.980726 15.2945 1.01536 15.3729C1.08679 15.5346 1.17943 15.7082 1.33359 15.8495C1.65594 16.1451 2.1296 16.1992 2.83091 16.1258L2.833 16.1255C3.10367 16.0972 3.40151 16.066 3.73964 16.0358L3.73965 16.0359L3.74815 16.035C4.21421 15.9814 5.40684 15.9663 7.00744 15.9756C8.59699 15.9848 10.5623 16.0176 12.5542 16.0554C13.3259 16.07 14.1022 16.0854 14.8624 16.1005C18.0157 16.1632 20.8911 16.2203 22.0116 16.1938L22.0179 16.1937L22.0441 16.1935L22.1458 16.1928C22.2346 16.1922 22.3641 16.1914 22.527 16.1907C22.8529 16.1891 23.312 16.1877 23.8448 16.1882C24.9099 16.1892 26.2676 16.1978 27.4443 16.2278C28.3624 16.271 29.2245 16.3882 30.0086 16.4952C30.1329 16.5126 30.2562 16.5292 30.3778 16.545C29.6643 17.233 28.9012 17.9505 28.2746 18.5343C27.887 18.8955 27.5521 19.2051 27.3141 19.4244C27.1951 19.534 27.1003 19.6211 27.0353 19.6807L26.9609 19.7489L26.9418 19.7665L26.9372 19.7706C24.8802 21.5958 22.9599 23.172 21.3797 24.336L21.3796 24.3359L21.3724 24.3415C21.1644 24.5035 20.974 24.6474 20.797 24.781C20.7457 24.8197 20.6955 24.8576 20.6464 24.8948C20.6462 24.895 20.646 24.8952 20.6457 24.8953L20.6113 24.9212C20.0859 25.3162 19.6383 25.6528 19.3673 25.9965C19.222 26.1809 19.1133 26.3833 19.0706 26.6155C19.0276 26.8491 19.0567 27.0846 19.1423 27.3263L19.1423 27.3263C19.3536 27.9225 20.002 28.2532 20.8091 28.3405C21.6351 28.4299 22.7291 28.2833 24.0303 27.8239L24.2675 27.7401L24.2672 27.7339C25.4155 27.2849 26.9286 26.4051 28.5845 25.2356Z"
                        fill="#E65631"
                        stroke="#E65631"
                        stroke-width="0.673226"
                    />
                </svg>
            </div>
        )
    }

    function CustomPrevArrow(props) {
        const { className, style, onClick } = props
        return (
            <div
                className={className + (arrowVisibilityPrev ? " flex" : " hidden")}
                style={{
                    alignItems: "center",
                    justifyItems: "end",
                    width: "40px",
                    height: "40px",
                    position: "absolute",
                    left: "20px",
                    backgroundImage: "none",
                    transform: "",
                }}
                onClick={onClick}
            >
                <svg width="41" height="29" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.0126 3.41451L13.0049 3.4194L12.9974 3.42471L8.54779 6.58144C8.54749 6.58165 8.54719 6.58186 8.5469 6.58206C8.12509 6.87734 7.67805 7.19741 7.25062 7.59391C4.60785 9.66714 3.00593 11.1139 2.05229 12.1453C1.13382 13.1385 0.772006 13.7921 0.709462 14.2875L0.707942 14.2927C0.56418 14.7805 0.739427 15.4056 1.60868 16.4434C2.48931 17.4947 4.15612 19.0568 7.21601 21.4571C7.64343 21.8536 8.09047 22.1737 8.51228 22.4689C8.51258 22.4692 8.51287 22.4694 8.51317 22.4696L12.9628 25.6263L12.9702 25.6316L12.9779 25.6364C14.812 26.7938 16.4683 27.6282 17.6613 27.9812L17.6613 27.9812C18.9848 28.3727 20.0851 28.4623 20.9053 28.3299C21.707 28.2004 22.3371 27.8357 22.5168 27.2284L22.5168 27.2281C22.5893 26.9825 22.6055 26.7461 22.5502 26.5153C22.4952 26.286 22.376 26.0896 22.2213 25.9131C21.9323 25.5832 21.467 25.2697 20.9209 24.9017L20.8881 24.8796C20.8881 24.8796 20.888 24.8796 20.8879 24.8795C20.8367 24.8448 20.7845 24.8094 20.731 24.7733C20.5473 24.6491 20.3496 24.5155 20.1335 24.3646L20.1336 24.3645L20.1259 24.3594C18.4871 23.2799 16.4886 21.8049 14.3371 20.0912L14.3346 20.0892L14.321 20.078L14.2677 20.034L14.0654 19.8667C13.8912 19.7225 13.6427 19.5162 13.3458 19.2682C12.945 18.9335 12.456 18.5231 11.9421 18.0869C12.635 18.1185 13.396 18.1437 14.2336 18.1605C14.8092 18.2193 15.3541 18.208 15.8679 18.1894L32.3512 18.7067L32.3702 18.7073L32.3892 18.7058C33.1608 18.6425 33.8798 18.6269 34.5489 18.6123C34.8029 18.6068 35.0497 18.6014 35.2895 18.5936C36.1422 18.566 36.9223 18.5083 37.5416 18.2764C38.817 17.8004 39.5858 17.3259 39.9861 16.8174C40.1925 16.5552 40.3022 16.2826 40.3289 16.0027C40.3553 15.727 40.2991 15.4674 40.2109 15.2315C40.1764 15.1391 40.1468 15.0511 40.1175 14.9635L40.1145 14.9544C40.0868 14.8718 40.0583 14.7866 40.0279 14.7065C39.965 14.5413 39.8816 14.3631 39.735 14.2139C39.4286 13.9019 38.9584 13.8231 38.2542 13.8597L38.2521 13.8598C37.9803 13.874 37.6813 13.8895 37.342 13.902L37.342 13.9019L37.3335 13.9024C36.8652 13.9315 35.6735 13.8841 34.0755 13.7911C32.4886 13.6987 30.5278 13.5631 28.5406 13.4211C27.7706 13.3661 26.9962 13.3101 26.2379 13.2552C23.0921 13.0276 20.2237 12.8201 19.1033 12.7879L19.0971 12.7877L19.0709 12.7865L18.9693 12.7819C18.8806 12.7778 18.7512 12.7718 18.5885 12.7641C18.263 12.7485 17.8045 12.7259 17.2724 12.6975C16.2088 12.6408 14.8534 12.5612 13.6799 12.4696C12.7653 12.3784 11.9105 12.2163 11.1331 12.0684C11.0099 12.0445 10.8876 12.0215 10.767 11.9994C11.5155 11.3496 12.3152 10.673 12.9714 10.1228C13.3774 9.78246 13.7281 9.4908 13.9772 9.28425C14.1018 9.18098 14.201 9.099 14.269 9.04287L14.3469 8.97862L14.3669 8.96211L14.3717 8.95819C16.5214 7.24319 18.5215 5.76966 20.1606 4.68999L20.1606 4.69009L20.1681 4.68486C20.3843 4.5339 20.582 4.40026 20.7657 4.27609C20.8189 4.24008 20.871 4.20487 20.9221 4.17026C20.9223 4.1701 20.9225 4.16994 20.9228 4.16978L20.9585 4.14572C21.5039 3.77876 21.9685 3.46614 22.2571 3.13701C22.4118 2.96053 22.531 2.76402 22.5858 2.53438C22.6409 2.30337 22.6242 2.06671 22.5513 1.82088L22.5513 1.82084C22.3715 1.21436 21.7413 0.850189 20.9399 0.720761C20.1198 0.588309 19.0195 0.677462 17.6961 1.06813L17.4548 1.13936L17.4548 1.14555C16.2846 1.53385 14.7275 2.33332 13.0126 3.41451Z"
                        fill="#DF7E2D"
                        stroke="#DF7E2D"
                        stroke-width="0.673226"
                    />
                </svg>
            </div>
        )
    }

    return (
        <>
            <div className={" relative mx-auto mb-12  bg-white lg:mb-24 bg-[url(/src/bgimages/bg-receipts-mobile.png)] md:bg-[url(/src/bgimages/bg-receipts-desktop.png)]"}>
                <div className="grid grid-cols-1 max-w-[1000px] md:grid-cols-2  mx-auto items-center  py-12 gap-x-12">
                    <div>  <h2 className="h2 md:mb-6 md:pt-12 text-center md:text-left font-Alpro max-w-[90%] md:max-w-full mx-auto text-[58px] uppercase text-white md:pr-12">Entdecke unsere pflantastisch leckeren Frühstücks-Rezepte</h2>
                        <div className="mx-auto hidden md:block mb-1  pb-12  max-w-[80%] md:max-w-full ">
                            <a
                                href="https://www.alpro.com/de/rezepte?courses=breakfast"
                                target="_blank"
                                rel="noreferrer noopener"
                                className="mb-6 mt-12 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
                            >
                                Alle Rezepte ansehen
                            </a>
                        </div>
                    </div>
                    <div className="justify-self-start self-start mt-12 max-w-[90%] mx-auto md:max-w-full">	<a
                        href="https://www.alpro.com/de/rezepte/heidelbeer-knuspertraum" target="_blank" ><img src={process.env.PUBLIC_URL + "/images/bg-cake.png"} className="z-2 relative mx-auto" /></a>
                        <p className="text-center font-Alpro text-[26px] uppercase text-white mt-6">Heidelbeer Knuspertraum</p>
                    </div>
                    <div className="mx-auto block md:hidden mb-1  pb-0 md:pb-12  max-w-[80%] md:max-w-full ">
                        <a
                            href="https://www.alpro.com/de/rezepte?courses=breakfast"
                            target="_blank"
                            rel="noreferrer noopener"
                            className="mb-6 mt-4 block w-[100%] bg-blue p-4 font-Alpro text-[20px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
                        >
                            Alle Rezepte ansehen
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Rezepte
